/* Lockett Labs Events: one show (/pages/event-show/<handle>).
   Ported from sections/event-detail.liquid's script (kept as the rollback):
   the map, directions, resources and zip, traders filter, lightbox, menus,
   Eventbrite and the phone bar behave exactly as they did. New: the hero
   clock, the in-page menu, and live traders, tickets and table status from
   the events desk. */
(function () {
  'use strict';
  var EV = window.EV;
  var root = document.querySelector('[data-ev-show]');
  if (!EV || !root) return;

  var BOOKED_KEY = 'll_tickets_booked';
  var API = EV.apiBase(root.getAttribute('data-api') || '');
  var d = {
    handle: root.getAttribute('data-handle') || '',
    status: root.getAttribute('data-status') || '',
    name: root.getAttribute('data-name') || 'Lockett Labs show',
    start: root.getAttribute('data-start') || '',
    end: root.getAttribute('data-end') || '',
    isoStart: root.getAttribute('data-iso-start') || '',
    isoEnd: root.getAttribute('data-iso-end') || '',
    where: root.getAttribute('data-where') || '',
    url: root.getAttribute('data-url') || location.href,
    when: root.getAttribute('data-when') || ''
  };

  /* ---------------------------------------------------------------- saved, booked, clocks */
  EV.paintBells(root);
  document.addEventListener(EV.WATCH_EVT, function () { EV.paintBells(root); });
  var bookedEl = root.querySelector('[data-ev-booked]');
  function paintBooked() { if (bookedEl) bookedEl.hidden = EV.readList(BOOKED_KEY).indexOf(d.handle) === -1; }
  paintBooked();
  EV.clock(root.querySelector('[data-ev-cd]'), root.querySelector('[data-ev-cd-label]'));

  /* Run of the day marks the slot on now, only on the day itself. */
  var run = root.querySelector('[data-ev-run]');
  function paintRun() {
    if (!run) return;
    var day = run.getAttribute('data-day');
    var t = new Date();
    var pad = function (n) { return n < 10 ? '0' + n : String(n); };
    if (day !== t.getFullYear() + '-' + pad(t.getMonth() + 1) + '-' + pad(t.getDate())) return;
    var now = t.getHours() * 60 + t.getMinutes();
    var rows = Array.prototype.slice.call(run.querySelectorAll('.ev-run__row'));
    var cur = -1;
    rows.forEach(function (r, i) {
      var at = (r.getAttribute('data-at') || '').split(':');
      if ((parseInt(at[0], 10) || 0) * 60 + (parseInt(at[1], 10) || 0) <= now) cur = i;
    });
    rows.forEach(function (r, i) {
      r.classList.toggle('is-done', i < cur);
      r.classList.toggle('is-now', i === cur);
      var b = r.querySelector('[data-ev-run-now]');
      if (b) b.hidden = i !== cur;
    });
  }
  paintRun();
  setInterval(function () { if (!document.hidden) paintRun(); }, 60000);

  /* ---------------------------------------------------------------- in-page menu */
  var spies = document.querySelectorAll('[data-evs-spy]');
  if (spies.length && 'IntersectionObserver' in window) {
    var byId = {};
    spies.forEach(function (a) { byId[a.getAttribute('data-evs-spy')] = a; });
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (!en.isIntersecting || !byId[en.target.id]) return;
        spies.forEach(function (x) { x.removeAttribute('aria-current'); });
        byId[en.target.id].setAttribute('aria-current', 'true');
      });
    }, { rootMargin: '-40% 0px -55% 0px' });
    Object.keys(byId).forEach(function (id) { var t = document.getElementById(id); if (t) io.observe(t); });
  }

  /* ---------------------------------------------------------------- resources */
  (function () {
    var wrap = root.querySelector('[data-ev-res]');
    if (!wrap) return;
    var cards = Array.prototype.map.call(wrap.querySelectorAll('[data-ev-rcard]'), function (el) { return { el: el, aud: el.getAttribute('data-aud') || '' }; });
    var emptyEl = wrap.querySelector('[data-ev-rempty]');
    wrap.addEventListener('click', function (ev) {
      var chip = ev.target.closest('[data-ev-raud]');
      if (!chip) return;
      var want = chip.getAttribute('data-ev-raud') || '';
      wrap.querySelectorAll('[data-ev-raud]').forEach(function (b) { b.setAttribute('aria-pressed', (b.getAttribute('data-ev-raud') || '') === want ? 'true' : 'false'); });
      var hits = 0;
      cards.forEach(function (c) { var ok = !want || !c.aud || c.aud === want; if (ok) hits++; if (c.el.hidden === ok) c.el.hidden = !ok; });
      if (emptyEl) emptyEl.hidden = hits !== 0;
    });

    var zipBtn = wrap.querySelector('[data-ev-zip]');
    if (!zipBtn) return;
    var MAX = 400 * 1024 * 1024;
    var TABLE = (function () {
      var t = new Uint32Array(256);
      for (var i = 0; i < 256; i++) { var c = i; for (var k = 0; k < 8; k++) c = (c & 1) ? (0xEDB88320 ^ (c >>> 1)) : (c >>> 1); t[i] = c >>> 0; }
      return t;
    })();
    function crc32(b) { var c = 0xFFFFFFFF; for (var i = 0; i < b.length; i++) c = TABLE[(c ^ b[i]) & 0xFF] ^ (c >>> 8); return (c ^ 0xFFFFFFFF) >>> 0; }
    /* Stored, never deflated: posters, PDFs and zips are compressed already. */
    function buildZip(files) {
      var enc = new TextEncoder(), parts = [], central = [], offset = 0, n = new Date();
      var time = ((n.getHours() & 31) << 11) | ((n.getMinutes() & 63) << 5) | ((n.getSeconds() >> 1) & 31);
      var date = (((n.getFullYear() - 1980) & 127) << 9) | (((n.getMonth() + 1) & 15) << 5) | (n.getDate() & 31);
      files.forEach(function (f) {
        var name = enc.encode(f.name), sum = crc32(f.data), len = f.data.length;
        var lh = new DataView(new ArrayBuffer(30));
        lh.setUint32(0, 0x04034b50, true); lh.setUint16(4, 20, true); lh.setUint16(6, 0x0800, true); lh.setUint16(8, 0, true);
        lh.setUint16(10, time, true); lh.setUint16(12, date, true); lh.setUint32(14, sum, true); lh.setUint32(18, len, true);
        lh.setUint32(22, len, true); lh.setUint16(26, name.length, true); lh.setUint16(28, 0, true);
        parts.push(lh.buffer, name, f.data);
        var cd = new DataView(new ArrayBuffer(46));
        cd.setUint32(0, 0x02014b50, true); cd.setUint16(4, 20, true); cd.setUint16(6, 20, true); cd.setUint16(8, 0x0800, true);
        cd.setUint16(10, 0, true); cd.setUint16(12, time, true); cd.setUint16(14, date, true); cd.setUint32(16, sum, true);
        cd.setUint32(20, len, true); cd.setUint32(24, len, true); cd.setUint16(28, name.length, true); cd.setUint32(30, 0, true);
        cd.setUint32(34, 0, true); cd.setUint32(38, 0, true); cd.setUint32(42, offset, true);
        central.push(cd.buffer, name);
        offset += 30 + name.length + len;
      });
      var cdSize = central.reduce(function (a, p) { return a + p.byteLength; }, 0);
      var end = new DataView(new ArrayBuffer(22));
      end.setUint32(0, 0x06054b50, true); end.setUint32(4, 0, true); end.setUint16(8, files.length, true); end.setUint16(10, files.length, true);
      end.setUint32(12, cdSize, true); end.setUint32(16, offset, true); end.setUint16(20, 0, true);
      return new Blob(parts.concat(central, [end.buffer]), { type: 'application/zip' });
    }
    function fileName(url, title, used) {
      var base = (url || '').split('?')[0].split('/').pop() || '';
      try { base = decodeURIComponent(base); } catch (e) { /* keep raw */ }
      if (base.indexOf('.') < 1) base = (title || 'file').replace(/[^\w\- .]+/g, '').trim();
      base = base.replace(/[\\/:*?"<>|]+/g, '-') || 'file';
      var dot = base.lastIndexOf('.'), name = base, i = 2;
      while (used[name.toLowerCase()]) { name = dot > 0 ? base.slice(0, dot) + '-' + i + base.slice(dot) : base + '-' + i; i++; }
      used[name.toLowerCase()] = true;
      return name;
    }
    var busy = false;
    zipBtn.addEventListener('click', function () {
      if (busy) return;
      var picked = cards.filter(function (c) { return c.el.getAttribute('data-zip') === '1' && !c.el.hidden; })
        .map(function (c) { return { url: c.el.getAttribute('data-url'), title: c.el.getAttribute('data-title') }; });
      if (!picked.length) { EV.toast('Nothing in that group can be bundled'); return; }
      busy = true;
      zipBtn.disabled = true;
      var label = zipBtn.textContent;
      var got = [], used = {}, done = 0, skipped = 0, total = 0, tooBig = false;
      var tick = function () { zipBtn.textContent = 'Fetching ' + done + ' of ' + picked.length; };
      tick();
      picked.reduce(function (chain, it) {
        return chain.then(function () {
          if (tooBig) return;
          return fetch(it.url, { credentials: 'omit' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.arrayBuffer(); })
            .then(function (buf) { total += buf.byteLength; if (total > MAX) { tooBig = true; return; } got.push({ name: fileName(it.url, it.title, used), data: new Uint8Array(buf) }); })
            .catch(function () { skipped++; }).then(function () { done++; tick(); });
        });
      }, Promise.resolve()).then(function () {
        zipBtn.textContent = label;
        zipBtn.disabled = false;
        busy = false;
        if (tooBig) { EV.toast('Too much to bundle in a browser, take them one at a time'); return; }
        if (!got.length) { EV.toast('None of those could be fetched'); return; }
        var url = URL.createObjectURL(buildZip(got));
        var a = EV.el('a', { href: url, download: (zipBtn.getAttribute('data-zipname') || 'show') + '-press-kit.zip' });
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(url); }, 10000);
        EV.toast(skipped ? got.length + ' bundled, ' + skipped + ' could not be fetched' : got.length + ' files bundled');
      });
    });
  })();

  /* ---------------------------------------------------------------- who's trading */
  /* Sponsors by level, then the first twelve other traders; each opens their
     profile. Server-rendered from the show's list, then swapped for the
     desk's live list when it answers with traders. */
  var INLINE = 12;
  var vWrap = root.querySelector('[data-ev-vendors]');
  // every trader, for the See every trader sheet: the page's own list first, the desk's once it answers
  var allList = [];
  try { allList = JSON.parse(((vWrap && vWrap.querySelector('[data-ev-vall-data]')) || {}).textContent || '[]').map(EV.vendorFrom).filter(function (v) { return v.name; }); } catch (e) { allList = []; }
  function openVendor(v) {
    EV.vendorDialog(v, { event: d.name, url: d.url + '#traders', campaign: d.handle });
  }
  if (vWrap) {
    vWrap.addEventListener('click', function (ev) {
      // See every trader, and the line under the list: the whole list over the page
      var all = ev.target.closest('[data-ev-vall-link], [data-ev-vmore-link]');
      if (all && allList.length && EV.allTraders) {
        ev.preventDefault();
        EV.allTraders(allList, { event: d.name, date: d.when, url: d.url + '#traders', campaign: d.handle, pageUrl: all.href });
        return;
      }
      var row = ev.target.closest('[data-ev-vrow]');
      if (row) openVendor(EV.vendorFrom(row.getAttribute('data-ev-vrow')));
    });
  }
  function paintVendors(list) {
    if (!vWrap || !list.length) return;
    var sorted = EV.vendorSort(list);
    allList = sorted;
    var sp = sorted.filter(function (v) { return v.tier; });
    var rest = sorted.filter(function (v) { return !v.tier; });
    var spBox = vWrap.querySelector('[data-ev-vspons]');
    var grid = vWrap.querySelector('[data-ev-vlist]');
    spBox.textContent = '';
    sp.forEach(function (v) { spBox.append(EV.sponsorCard(v, openVendor)); });
    grid.textContent = '';
    rest.slice(0, INLINE).forEach(function (v) { grid.append(EV.vendorCard(v, openVendor)); });
    var more = vWrap.querySelector('[data-ev-vmore]');
    if (more) {
      more.hidden = rest.length <= INLINE;
      var a = more.querySelector('[data-ev-vmore-link]');
      if (a) { a.textContent = 'And ' + (rest.length - INLINE) + ' more: see all ' + sorted.length + ' traders, with search and categories '; a.append(EV.icon('arrow')); }
    }
    var lab = vWrap.querySelector('[data-ev-vall-label]');
    if (lab) lab.textContent = 'See every trader' + (sorted.length > INLINE ? ' (' + sorted.length + ')' : '');
    vWrap.hidden = false;
    var link = document.querySelector('[data-evs-traders-link]');
    if (link) link.hidden = false;
  }

  if (API && d.handle) {
    EV.api(API, 'public.php?action=vendors&handle=' + encodeURIComponent(d.handle)).then(function (res) {
      paintVendors((res.vendors || []).map(EV.vendorFrom));
    }).catch(function () { /* the server-rendered list stays */ });

    /* Ticket numbers, when the desk is connected to Eventbrite. */
    EV.api(API, 'public.php?action=tickets&handle=' + encodeURIComponent(d.handle)).then(function (res) {
      var t = res.tickets;
      if (!t || !t.capacity) return;
      var meter = root.querySelector('[data-ev-meter]');
      if (meter && d.status !== 'past') {
        var pct = Math.round(t.remaining / t.capacity * 100);
        meter.hidden = false;
        meter.querySelector('[data-ev-meter-n]').textContent = t.remaining + ' of ' + t.capacity;
        meter.querySelector('[data-ev-meter-label]').textContent = t.remaining === 0 ? 'All gone' : pct < 20 ? 'Selling fast' : 'Tickets left';
        var fill = meter.querySelector('[data-ev-meter-fill]');
        fill.style.width = Math.max(2, pct) + '%';
        fill.className = 'ev-meter__fill' + (t.remaining === 0 ? ' is-out' : pct < 20 ? ' is-low' : '');
      }
      var cap = root.querySelector('[data-ev-capacity]');
      if (cap) cap.textContent = t.capacity + ' places';
      (t.tiers || []).forEach(function (tier) {
        var row = root.querySelector('[data-tier="' + CSS.escape(String(tier.name || '').toLowerCase()) + '"]');
        if (!row) return;
        row.classList.toggle('is-gone', tier.state === 'gone');
        var old = row.querySelector('.ev-tier__flag');
        if (old) old.remove();
        if (tier.state === 'gone' || tier.state === 'low') {
          row.querySelector('.ev-tier__tx').append(EV.el('span', { class: 'ev-tier__flag is-' + tier.state, text: tier.state === 'gone' ? 'Gone' : 'Few left' }));
        }
      });
    }).catch(function () { /* typed numbers stay */ });

    /* Tables open for this show? */
    var card = root.querySelector('[data-ev-applycard]');
    if (card) {
      EV.api(API, 'public.php?action=event&handle=' + encodeURIComponent(d.handle)).then(function (res) {
        var a = res.event && res.event.applications;
        if (!a || !a.accepting) return;
        var note = card.querySelector('[data-ev-applycard-note]');
        if (note) {
          var bits = [];
          if (a.state === 'waitlist') bits.push('Every table is taken, so new applications join the reserve list.');
          if (a.remaining != null) bits.push(a.remaining + (a.remaining === 1 ? ' place left.' : ' places left.'));
          if (a.closesAt) bits.push('Closes ' + new Date(a.closesAt).toLocaleDateString('en-GB', { day: 'numeric', month: 'long' }) + '.');
          if (bits.length) note.textContent = bits.join(' ');
        }
        card.hidden = false;
      }).catch(function () { /* card stays hidden */ });
    }
  }

  /* ---------------------------------------------------------------- map */
  var canvas = root.querySelector('[data-ev-map]');
  var dirs = root.querySelector('[data-ev-dirs]');
  var meLoc = null;

  function findPostcode(txt) {
    var m = String(txt || '').match(/\b[A-Z]{1,2}\d[A-Z\d]?\s*\d[A-Z]{2}\b/i);
    return m ? m[0].replace(/\s+/g, '').toUpperCase() : '';
  }
  function geocodePostcode(pc) {
    var key = 'll_geo_' + pc;
    try { var hit = JSON.parse(localStorage.getItem(key) || 'null'); if (hit && typeof hit.lat === 'number') return Promise.resolve(hit); } catch (e) { /* ignore */ }
    return fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(pc)).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
      if (!j || !j.result || typeof j.result.latitude !== 'number' || j.result.quality === 9) return null;
      var c = { lat: j.result.latitude, lon: j.result.longitude };
      try { localStorage.setItem(key, JSON.stringify(c)); } catch (e) { /* ignore */ }
      return c;
    }).catch(function () { return null; });
  }

  if (canvas) (function () {
    var tilesEl = canvas.querySelector('[data-ev-tiles]');
    var pinsEl = canvas.querySelector('[data-ev-pins]');
    var bootEl = canvas.querySelector('[data-ev-boot]');
    var venue = { lat: parseFloat(canvas.getAttribute('data-lat')), lon: parseFloat(canvas.getAttribute('data-lon')) };
    var postcode = canvas.getAttribute('data-postcode') || findPostcode(canvas.getAttribute('data-address'));
    var located = !isNaN(venue.lat) && !isNaN(venue.lon);
    if (!located && !postcode) { canvas.remove(); return; }
    var TILE = 256, ZMIN = 4, ZMAX = 18, ZHOME = 15;
    var view = { z: ZHOME, lat: venue.lat, lon: venue.lon };
    var booted = false;
    var cache = {};
    // The route from "Directions from me": [[lon, lat], ...], drawn between
    // the tiles and the pins. Dashed when it is only a straight line.
    var route = null;
    var SVGNS = 'http://www.w3.org/2000/svg';
    var routeEl = document.createElementNS(SVGNS, 'svg');
    routeEl.setAttribute('class', 'ev-map__route');
    routeEl.setAttribute('aria-hidden', 'true');
    var routeCase = document.createElementNS(SVGNS, 'path');
    var routeLine = document.createElementNS(SVGNS, 'path');
    routeCase.setAttribute('class', 'ev-map__route-case');
    routeLine.setAttribute('class', 'ev-map__route-line');
    routeEl.append(routeCase, routeLine);
    pinsEl.parentNode.insertBefore(routeEl, pinsEl);
    var ws = function (z) { return TILE * Math.pow(2, z); };
    var lonX = function (lon, z) { return (lon + 180) / 360 * ws(z); };
    var latY = function (lat, z) { var r = lat * Math.PI / 180; return (1 - Math.log(Math.tan(r) + 1 / Math.cos(r)) / Math.PI) / 2 * ws(z); };
    var xLon = function (x, z) { return x / ws(z) * 360 - 180; };
    var yLat = function (y, z) { var t = Math.PI - 2 * Math.PI * y / ws(z); return 180 / Math.PI * Math.atan(0.5 * (Math.exp(t) - Math.exp(-t))); };
    function box() { var r = canvas.getBoundingClientRect(); return { w: Math.max(1, Math.round(r.width)), h: Math.max(1, Math.round(r.height)) }; }
    function tl() { var b = box(); return { x: lonX(view.lon, view.z) - b.w / 2, y: latY(view.lat, view.z) - b.h / 2, w: b.w, h: b.h }; }
    function pinGlyph() {
      var NS = 'http://www.w3.org/2000/svg';
      var svg = document.createElementNS(NS, 'svg');
      svg.setAttribute('viewBox', '0 0 24 24');
      svg.setAttribute('fill', 'none');
      svg.setAttribute('stroke-width', '2.2');
      svg.setAttribute('stroke-linecap', 'round');
      svg.setAttribute('stroke-linejoin', 'round');
      var p = document.createElementNS(NS, 'path');
      p.setAttribute('d', 'M3 9V7a2 2 0 012-2h14a2 2 0 012 2v2a3 3 0 000 6v2a2 2 0 01-2 2H5a2 2 0 01-2-2v-2a3 3 0 000-6z');
      svg.appendChild(p);
      return svg;
    }
    function render() {
      if (!booted) return;
      var t = tl();
      var x0 = Math.floor(t.x / TILE), x1 = Math.floor((t.x + t.w) / TILE), y0 = Math.floor(t.y / TILE), y1 = Math.floor((t.y + t.h) / TILE);
      var span = Math.pow(2, view.z), want = {};
      for (var ty = y0; ty <= y1; ty++) {
        if (ty < 0 || ty >= span) continue;
        for (var tx = x0; tx <= x1; tx++) {
          var wx = ((tx % span) + span) % span;
          var key = view.z + '/' + wx + '/' + ty;
          want[key] = 1;
          var img = cache[key];
          if (!img) {
            img = new Image();
            img.className = 'ev-map__tile';
            img.alt = '';
            img.decoding = 'async';
            img.src = 'https://tile.openstreetmap.org/' + view.z + '/' + wx + '/' + ty + '.png';
            cache[key] = img;
            tilesEl.appendChild(img);
          }
          img.style.transform = 'translate3d(' + Math.round(tx * TILE - t.x) + 'px,' + Math.round(ty * TILE - t.y) + 'px,0)';
        }
      }
      Object.keys(cache).forEach(function (k) { if (!want[k]) { cache[k].remove(); delete cache[k]; } });
      drawRoute(t);
      pinsEl.textContent = '';
      var pin = EV.el('span', { class: 'ev-map__pin' });
      var head = EV.el('span');
      head.appendChild(pinGlyph());
      pin.append(head);
      pin.style.transform = 'translate3d(' + Math.round(lonX(venue.lon, view.z) - t.x) + 'px,' + Math.round(latY(venue.lat, view.z) - t.y) + 'px,0)';
      pinsEl.append(pin);
      if (meLoc) {
        var me = EV.el('span', { class: 'ev-map__me', title: 'Roughly where you are' });
        me.style.transform = 'translate3d(' + Math.round(lonX(meLoc.lon, view.z) - t.x) + 'px,' + Math.round(latY(meLoc.lat, view.z) - t.y) + 'px,0)';
        pinsEl.append(me);
      }
    }
    function drawRoute(t) {
      routeEl.setAttribute('width', t.w);
      routeEl.setAttribute('height', t.h);
      routeEl.setAttribute('viewBox', '0 0 ' + t.w + ' ' + t.h);
      routeEl.classList.toggle('is-straight', !!(route && route.straight));
      if (!route) { routeCase.setAttribute('d', ''); routeLine.setAttribute('d', ''); return; }
      // Points closer than a pixel or so add nothing at this zoom.
      var d = '', lx = 0, ly = 0, n = route.coords.length;
      for (var i = 0; i < n; i++) {
        var x = lonX(route.coords[i][0], view.z) - t.x, y = latY(route.coords[i][1], view.z) - t.y;
        if (i && i < n - 1 && Math.abs(x - lx) < 1.5 && Math.abs(y - ly) < 1.5) continue;
        d += (d ? 'L' : 'M') + x.toFixed(1) + ' ' + y.toFixed(1);
        lx = x; ly = y;
      }
      routeCase.setAttribute('d', d);
      routeLine.setAttribute('d', d);
    }
    function fitBoth() {
      if (!meLoc && !route) { view.z = ZHOME; view.lat = venue.lat; view.lon = venue.lon; render(); return; }
      var b = box(), pad = 56;
      var pts = [[venue.lon, venue.lat]];
      if (meLoc) pts.push([meLoc.lon, meLoc.lat]);
      if (route) pts = pts.concat(route.coords);
      var so = 90, no = -90, we = 180, ea = -180;
      pts.forEach(function (c) { so = Math.min(so, c[1]); no = Math.max(no, c[1]); we = Math.min(we, c[0]); ea = Math.max(ea, c[0]); });
      var z = ZMAX;
      for (; z > ZMIN; z--) {
        if (Math.abs(lonX(ea, z) - lonX(we, z)) <= b.w - pad * 2 && Math.abs(latY(so, z) - latY(no, z)) <= b.h - pad * 2) break;
      }
      // Centre in map space, not by averaging degrees, so a long route sits
      // in the middle of the frame rather than drifting north.
      view.z = z; view.lon = (we + ea) / 2; view.lat = yLat((latY(so, z) + latY(no, z)) / 2, z);
      render();
    }
    function resolve() {
      if (located) return Promise.resolve(true);
      return geocodePostcode(postcode).then(function (c) {
        if (!c) return false;
        venue.lat = view.lat = c.lat;
        venue.lon = view.lon = c.lon;
        located = true;
        if (dirs && dirs.__setCoords) dirs.__setCoords(c.lat, c.lon);
        return true;
      });
    }
    function boot() {
      if (booted) return;
      booted = true;
      resolve().then(function (ok) {
        if (!ok) { canvas.remove(); return; }
        if (bootEl) bootEl.hidden = true;
        render();
      });
    }
    canvas.querySelectorAll('[data-ev-zoom]').forEach(function (b) {
      b.addEventListener('click', function () { view.z = Math.min(ZMAX, Math.max(ZMIN, view.z + parseInt(b.getAttribute('data-ev-zoom'), 10))); render(); });
    });
    var re = canvas.querySelector('[data-ev-recentre]');
    if (re) re.addEventListener('click', fitBoth);
    // Drag to pan with a mouse only; on touch the page must keep scrolling.
    // The press is claimed (preventDefault) so the browser never starts a
    // text selection over the map: a selection made by one drag turned the
    // next press into a native drag-and-drop of the map's contents, which
    // cancelled the pan and left a ghost image under the cursor.
    var drag = null;
    var frame = 0;
    canvas.addEventListener('pointerdown', function (ev) {
      if (ev.pointerType !== 'mouse' || ev.button !== 0 || ev.target.closest('button, a')) return;
      ev.preventDefault();
      var sel = window.getSelection && window.getSelection();
      if (sel && sel.rangeCount && canvas.contains(sel.anchorNode)) sel.removeAllRanges();
      drag = { x: ev.clientX, y: ev.clientY, lat: view.lat, lon: view.lon, px: ev.clientX, py: ev.clientY };
      try { canvas.setPointerCapture(ev.pointerId); } catch (e) { /* the pointer is gone */ }
      canvas.classList.add('is-dragging');
    });
    canvas.addEventListener('pointermove', function (ev) {
      if (!drag) return;
      drag.px = ev.clientX;
      drag.py = ev.clientY;
      // One redraw per frame, however fast the mouse reports.
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = 0;
        if (!drag) return;
        view.lon = xLon(lonX(drag.lon, view.z) - (drag.px - drag.x), view.z);
        view.lat = Math.max(-85, Math.min(85, yLat(latY(drag.lat, view.z) - (drag.py - drag.y), view.z)));
        render();
      });
    });
    var endDrag = function () {
      if (drag && (drag.px !== drag.x || drag.py !== drag.y)) {
        // Land exactly where the mouse let go, even if a frame was pending.
        view.lon = xLon(lonX(drag.lon, view.z) - (drag.px - drag.x), view.z);
        view.lat = Math.max(-85, Math.min(85, yLat(latY(drag.lat, view.z) - (drag.py - drag.y), view.z)));
        render();
      }
      drag = null;
      canvas.classList.remove('is-dragging');
    };
    ['pointerup', 'pointercancel', 'lostpointercapture'].forEach(function (n) { canvas.addEventListener(n, endDrag); });
    canvas.addEventListener('dragstart', function (ev) { ev.preventDefault(); });
    var rf = null;
    window.addEventListener('resize', function () { clearTimeout(rf); rf = setTimeout(render, 150); }, { passive: true });
    if ('IntersectionObserver' in window) {
      var mio = new IntersectionObserver(function (en) { if (en.some(function (x) { return x.isIntersecting; })) { mio.disconnect(); boot(); } }, { rootMargin: '300px' });
      mio.observe(canvas);
    } else { boot(); }
    canvas.__fit = fitBoth;
    canvas.__setRoute = function (coords, straight) {
      route = coords && coords.length > 1 ? { coords: coords, straight: !!straight } : null;
      canvas.classList.toggle('has-route', !!route);
      if (booted) fitBoth();
    };
  })();

  /* ---------------------------------------------------------------- directions */
  if (dirs) (function () {
    var MODES = { driving: { g: 'driving', a: 'd', osm: 'fossgis_osrm_car' }, transit: { g: 'transit', a: 'r', osm: '' }, walking: { g: 'walking', a: 'w', osm: 'fossgis_osrm_foot' }, bicycling: { g: 'bicycling', a: '', osm: 'fossgis_osrm_bike' } };
    var mode = 'driving';
    var destQ = encodeURIComponent(dirs.getAttribute('data-dest') || '');
    var vLat = parseFloat(dirs.getAttribute('data-lat')), vLon = parseFloat(dirs.getAttribute('data-lon'));
    var has = !isNaN(vLat) && !isNaN(vLon);
    var g = dirs.querySelector('[data-ev-dir-google]'), ap = dirs.querySelector('[data-ev-dir-apple]'), osm = dirs.querySelector('[data-ev-dir-osm]'), waze = dirs.querySelector('[data-ev-dir-waze]');
    var msg = dirs.querySelector('[data-ev-locate-msg]'), loc = dirs.querySelector('[data-ev-locate]');
    var card = dirs.querySelector('[data-ev-route]');
    // OpenStreetMap routing (FOSSGIS, the engine behind openstreetmap.org's
    // own directions): free, no key, allows calls from the browser. Transit
    // has no open router, so it gets the straight line and the map apps.
    var PROFILE = { driving: 'routed-car', walking: 'routed-foot', bicycling: 'routed-bike' };
    var HOW = { driving: 'by car', walking: 'on foot', bicycling: 'by bike', transit: 'by public transport' };
    var routes = {};
    var routeAsk = 0;
    function say(t) { if (msg) { msg.textContent = t; msg.hidden = !t; } }
    dirs.__setCoords = function (la, lo) {
      vLat = la; vLon = lo; has = true;
      dirs.querySelectorAll('[data-ev-dir-waze], [data-ev-dir-osm]').forEach(function (a) { a.hidden = false; });
      paint();
      if (meLoc) showRoute();
    };
    function paint() {
      var m = MODES[mode];
      var origin = meLoc ? meLoc.lat + ',' + meLoc.lon : '';
      if (g) g.href = 'https://www.google.com/maps/dir/?api=1&destination=' + destQ + '&travelmode=' + m.g + (origin ? '&origin=' + encodeURIComponent(origin) : '');
      if (ap) ap.href = 'https://maps.apple.com/?daddr=' + destQ + (m.a ? '&dirflg=' + m.a : '') + (origin ? '&saddr=' + encodeURIComponent(origin) : '');
      if (waze) { waze.hidden = mode !== 'driving' || !has; if (has) waze.href = 'https://waze.com/ul?ll=' + vLat + ',' + vLon + '&navigate=yes'; }
      if (osm && has) {
        if (origin && m.osm) { osm.href = 'https://www.openstreetmap.org/directions?engine=' + m.osm + '&route=' + encodeURIComponent(origin) + ';' + vLat + ',' + vLon; osm.textContent = 'Route on OpenStreetMap'; }
        else { osm.href = 'https://www.openstreetmap.org/?mlat=' + vLat + '&mlon=' + vLon + '#map=16/' + vLat + '/' + vLon; osm.textContent = 'Bigger map'; }
      }
    }
    dirs.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-ev-mode]');
      if (!b) return;
      mode = b.getAttribute('data-ev-mode');
      dirs.querySelectorAll('[data-ev-mode]').forEach(function (x) { x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
      paint();
      if (meLoc) showRoute();
    });
    function miles(a, b) {
      var R = 3958.8, r = Math.PI / 180, dLa = (b.lat - a.lat) * r, dLo = (b.lon - a.lon) * r;
      var h = Math.sin(dLa / 2) * Math.sin(dLa / 2) + Math.cos(a.lat * r) * Math.cos(b.lat * r) * Math.sin(dLo / 2) * Math.sin(dLo / 2);
      return R * 2 * Math.atan2(Math.sqrt(h), Math.sqrt(1 - h));
    }
    function fmtMiles(mi) { return mi < 0.1 ? '0.1' : mi < 10 ? mi.toFixed(1) : String(Math.round(mi)); }
    function fmtTime(mins) {
      var m = Math.max(1, Math.round(mins));
      if (m < 60) return m + ' min';
      var h = Math.floor(m / 60), r = m % 60;
      return h + ' hr' + (r ? ' ' + r + ' min' : '');
    }
    function setCard(milesTxt, unit, lead, note, busy) {
      if (!card) return;
      card.hidden = false;
      card.classList.toggle('is-busy', !!busy);
      card.querySelector('[data-ev-route-miles]').textContent = milesTxt;
      card.querySelector('[data-ev-route-unit]').textContent = unit;
      card.querySelector('[data-ev-route-time]').textContent = lead;
      card.querySelector('[data-ev-route-note]').textContent = note;
    }
    /* The route itself. The visitor's position is rounded to about 100 m
       before it leaves the browser: plenty for a route to a venue, and
       nobody's front door goes to a third party. */
    function fetchRoute(m) {
      var key = m + '|' + meLoc.lat.toFixed(3) + ',' + meLoc.lon.toFixed(3);
      if (routes[key]) return Promise.resolve(routes[key]);
      var url = 'https://routing.openstreetmap.de/' + PROFILE[m] + '/route/v1/driving/'
        + meLoc.lon.toFixed(3) + ',' + meLoc.lat.toFixed(3) + ';' + vLon + ',' + vLat
        + '?overview=full&geometries=geojson&alternatives=false&steps=false';
      var ctrl = 'AbortController' in window ? new AbortController() : null;
      var timer = setTimeout(function () { if (ctrl) ctrl.abort(); }, 10000);
      return fetch(url, ctrl ? { signal: ctrl.signal } : {}).then(function (r) { return r.ok ? r.json() : null; }).then(function (j) {
        clearTimeout(timer);
        var rt = j && j.code === 'Ok' && j.routes && j.routes[0];
        if (!rt || !rt.geometry || !rt.geometry.coordinates || rt.geometry.coordinates.length < 2) return null;
        var out = { miles: rt.distance / 1609.344, mins: rt.duration / 60, coords: rt.geometry.coordinates };
        // The route starts at the rounded point; begin the line where they really are.
        out.coords = [[meLoc.lon, meLoc.lat]].concat(out.coords, [[vLon, vLat]]);
        routes[key] = out;
        return out;
      }).catch(function () { clearTimeout(timer); return null; });
    }
    function straight(note) {
      var mi = miles(meLoc, { lat: vLat, lon: vLon });
      setCard(fmtMiles(mi), mi >= 0.95 && mi < 1.05 ? 'mile' : 'miles', 'As the crow flies', note);
      if (canvas && canvas.__setRoute) canvas.__setRoute([[meLoc.lon, meLoc.lat], [vLon, vLat]], true);
    }
    function showRoute() {
      if (!has || !meLoc) return;
      var ask = ++routeAsk;
      if (mode === 'transit' || !PROFILE[mode]) {
        straight('For trains and buses, open Google or Apple Maps below: they have the timetables.');
        return;
      }
      setCard('…', 'miles', 'Planning the route ' + HOW[mode], '', true);
      fetchRoute(mode).then(function (r) {
        if (ask !== routeAsk) return;
        if (!r) { straight('The road route could not be planned just now. Google or Apple Maps below will.'); return; }
        var long = (mode === 'walking' && r.mins > 180) || (mode === 'bicycling' && r.mins > 300);
        setCard(fmtMiles(r.miles), r.miles >= 0.95 && r.miles < 1.05 ? 'mile' : 'miles', 'About ' + fmtTime(r.mins) + ' ' + HOW[mode],
          long ? 'That is a long way ' + HOW[mode] + '. Try Drive or Transit above.'
            : (mode === 'driving' ? 'Before traffic. ' : '') + 'Route from OpenStreetMap.');
        if (canvas && canvas.__setRoute) canvas.__setRoute(r.coords, false);
      });
    }
    if (loc) loc.addEventListener('click', function () {
      if (!navigator.geolocation) { say('This browser will not share a location.'); return; }
      loc.disabled = true;
      say('Finding you...');
      navigator.geolocation.getCurrentPosition(function (pos) {
        loc.disabled = false;
        meLoc = { lat: pos.coords.latitude, lon: pos.coords.longitude };
        loc.setAttribute('aria-pressed', 'true');
        paint(); say('');
        if (canvas && canvas.__fit) canvas.__fit();
        showRoute();
        var mapBox = canvas || card;
        if (mapBox && mapBox.getBoundingClientRect().top < 0) mapBox.scrollIntoView({ block: 'center', behavior: EV.reduce.matches ? 'auto' : 'smooth' });
      }, function () { loc.disabled = false; say('Could not get a location. The links below still work.'); }, { enableHighAccuracy: false, timeout: 9000, maximumAge: 600000 });
    });
    paint();
  })();

  /* ---------------------------------------------------------------- lightbox */
  root.addEventListener('click', function (ev) {
    var btn = ev.target.closest('button[data-full]');
    if (!btn) return;
    ev.preventDefault();
    var dlg = EV.el('dialog', { class: 'ev-lightbox', 'aria-label': 'Image' });
    var x = EV.el('button', { type: 'button', 'aria-label': 'Close', text: '×' });
    dlg.append(EV.el('img', { src: btn.getAttribute('data-full'), alt: '' }), x);
    var close = function () { if (dlg.open) dlg.close(); dlg.remove(); };
    dlg.addEventListener('click', function (e2) { if (e2.target === dlg || e2.target === x) close(); });
    dlg.addEventListener('close', function () { dlg.remove(); });
    document.body.append(dlg);
    dlg.showModal();
    x.focus();
  });

  /* ---------------------------------------------------------------- calendar and share */
  function calGoogle() {
    return 'https://calendar.google.com/calendar/render?' + new URLSearchParams({ action: 'TEMPLATE', text: d.name + ' (Lockett Labs)', dates: d.start + '/' + (d.end || d.start), location: d.where, details: d.url }).toString();
  }
  function calOutlook() {
    return 'https://outlook.live.com/calendar/0/deeplink/compose?' + new URLSearchParams({ subject: d.name + ' (Lockett Labs)', startdt: d.isoStart, enddt: d.isoEnd || d.isoStart, location: d.where, body: d.url }).toString();
  }
  var gl = root.querySelector('[data-ev-cal-google]'); if (gl) gl.href = calGoogle();
  var ol = root.querySelector('[data-ev-cal-outlook]'); if (ol) ol.href = calOutlook();
  var wa = root.querySelector('[data-ev-share-wa]'); if (wa) wa.href = 'https://wa.me/?text=' + encodeURIComponent(d.name + ': ' + d.url);
  var fb = root.querySelector('[data-ev-share-fb]'); if (fb) fb.href = 'https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(d.url);
  if (navigator.share) root.querySelectorAll('[data-ev-share-native], [data-ev-share-native2]').forEach(function (b) { b.hidden = false; });
  function discordBlock() { return ['**' + d.name + '**', d.when, d.where, d.url].filter(Boolean).join('\n'); }

  /* ---------------------------------------------------------------- Eventbrite */
  var ebBtn = root.querySelector('[data-ev-eb]');
  var ebId = ebBtn ? ebBtn.getAttribute('data-ev-eb') : '';
  var ebBound = false;
  function ebBind() {
    if (ebBound || !ebBtn || !window.EBWidgets) return Promise.resolve();
    try {
      window.EBWidgets.createWidget({ widgetType: 'checkout', eventId: ebId, modal: true, modalTriggerElementId: ebBtn.id, onOrderComplete: orderComplete });
      ebBound = true;
    } catch (err) { return Promise.reject(err); }
    return Promise.resolve();
  }
  /* Warm the script once the ticket panel is near, so the modal opens at once. */
  if (ebBtn && 'IntersectionObserver' in window) {
    var slabIO = new IntersectionObserver(function (en) {
      if (!en.some(function (x) { return x.isIntersecting; })) return;
      slabIO.disconnect();
      EV.loadEventbrite().then(ebBind).catch(function () {});
    }, { rootMargin: '400px' });
    slabIO.observe(root.querySelector('[data-ev-slab]'));
  }
  function orderComplete() {
    var list = EV.readList(BOOKED_KEY);
    if (list.indexOf(d.handle) === -1) { list.push(d.handle); EV.writeList(BOOKED_KEY, list); }
    paintBooked();
    var buy = root.querySelector('[data-ev-buybox]');
    var done = root.querySelector('[data-ev-done]');
    if (buy) buy.hidden = true;
    if (done) { done.hidden = false; setTimeout(function () { done.focus({ preventScroll: false }); }, 400); }
    EV.toast('Booked. Check your email for the ticket.');
    try { document.dispatchEvent(new CustomEvent('lle:order-complete', { detail: { eventId: ebId, handle: d.handle } })); } catch (e) { /* old browser */ }
  }
  function openCheckout(trigger) {
    if (!ebBtn) {
      var slab = root.querySelector('[data-ev-slab]');
      if (slab) slab.scrollIntoView({ behavior: EV.reduce.matches ? 'auto' : 'smooth', block: 'center' });
      return;
    }
    if (ebBound) { ebBtn.click(); return; }
    var label = ebBtn.querySelector('[data-ev-eb-label]');
    var was = label ? label.textContent : '';
    ebBtn.classList.add('is-busy');
    if (trigger) trigger.classList.add('is-busy');
    if (label) label.textContent = 'Opening checkout';
    EV.loadEventbrite().then(ebBind).then(function () {
      ebBtn.classList.remove('is-busy');
      if (trigger) trigger.classList.remove('is-busy');
      if (label) label.textContent = was;
      setTimeout(function () { ebBtn.click(); }, 60);
    }).catch(function () {
      ebBtn.classList.remove('is-busy');
      if (trigger) trigger.classList.remove('is-busy');
      if (label) label.textContent = was;
      // A blocked script used to leave a dead button. The hosted page is a working checkout.
      window.open('https://www.eventbrite.co.uk/e/' + encodeURIComponent(ebId), '_blank', 'noopener');
    });
  }

  /* Eventbrite draws its checkout as a full-screen frame with its own close
     button inside. When the frame cannot load (a draft, cancelled or mistyped
     event, or a blocker) there is no close at all and the page is stuck
     behind it, so the checkout always sits under a slim bar of ours: the
     show, a way out, and the hosted page as a fallback. Closing copies
     Eventbrite's own routine (fade the shared overlay, give the page its
     scrolling back, drop the frame) so the button opens it again later. */
  var ebBar = null;
  var ebFocus = null;
  function ebFrame() { return ebId ? document.getElementById('eventbrite-widget-modal-' + ebId) : null; }
  function ebBarOpen() {
    if (ebBar) return;
    ebFocus = document.activeElement;
    var x = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    x.setAttribute('viewBox', '0 0 24 24'); x.setAttribute('aria-hidden', 'true');
    var xp = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    xp.setAttribute('d', 'M6 6l12 12M18 6L6 18');
    x.appendChild(xp);
    var close = EV.el('button', { type: 'button', class: 'ev-ebbar__close', onclick: ebClose }, el2('span', 'Close'), x);
    ebBar = EV.el('div', { class: 'ev-ebbar', role: 'region', 'aria-label': 'Ticket checkout' },
      EV.el('span', { class: 'ev-ebbar__t' }, EV.el('b', { text: d.name || 'Tickets' }), EV.el('small', { text: 'Secure checkout by Eventbrite' })),
      EV.el('a', { class: 'ev-ebbar__alt', href: 'https://www.eventbrite.co.uk/e/' + encodeURIComponent(ebId), target: '_blank', rel: 'noopener', text: 'Open on Eventbrite' }),
      close);
    document.body.appendChild(ebBar);
    document.documentElement.classList.add('ev-eb-open');
  }
  function el2(tag, text) { return EV.el(tag, { text: text }); }
  function ebBarDrop() {
    if (!ebBar) return;
    ebBar.remove();
    ebBar = null;
    document.documentElement.classList.remove('ev-eb-open');
    if (ebFocus && ebFocus.focus && document.contains(ebFocus)) ebFocus.focus({ preventScroll: true });
  }
  function ebClose() {
    var ov = document.getElementById('eventbrite-widget-modal-overlay');
    if (ov) { ov.style.opacity = 0; ov.style.background = 'rgba(0, 0, 0, 0)'; ov.style.width = 0; ov.style.height = 0; }
    document.body.style.overflow = '';
    document.body.style.position = '';
    var f = ebFrame();
    if (f && f.parentNode) f.parentNode.removeChild(f);
    ebBarDrop();
  }
  if (ebBtn && 'MutationObserver' in window) {
    // The frame is added to and removed from <body> by Eventbrite; follow it.
    new MutationObserver(function () {
      if (ebFrame()) ebBarOpen(); else ebBarDrop();
    }).observe(document.body, { childList: true });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && ebBar) ebClose(); });
  }

  /* ---------------------------------------------------------------- clicks */
  document.addEventListener('click', function (ev) {
    var t = ev.target;
    var buy = t.closest('[data-ev-buy]');
    if (buy && ebBtn) { ev.preventDefault(); openCheckout(buy); return; }
    if (!root.contains(t)) return;

    var bell = t.closest('[data-ev-save]');
    if (bell) { ev.preventDefault(); var on = EV.toggleWatch(bell.getAttribute('data-ev-save')); EV.paintBells(root); EV.toast(on ? 'Saved to your list' : 'Removed from your list'); return; }
    if (t.closest('[data-ev-ics]')) { ev.preventDefault(); EV.downloadIcs(d); return; }
    var cp = t.closest('[data-ev-copy]');
    if (cp) { ev.preventDefault(); EV.copyText(cp.getAttribute('data-ev-copy'), 'Copied'); return; }
    if (t.closest('[data-ev-share-discord]')) { ev.preventDefault(); EV.copyText(discordBlock(), 'Copied, ready to paste into Discord'); return; }
    if (t.closest('[data-ev-share-native], [data-ev-share-native2]')) { ev.preventDefault(); if (navigator.share) navigator.share({ title: d.name, text: d.name + ', ' + d.when, url: EV.shortLink(d.url, 'device') || d.url }).catch(function () {}); return; }
    var menuBtn = t.closest('[data-ev-menu]');
    if (menuBtn) {
      ev.preventDefault();
      var which = menuBtn.getAttribute('data-ev-menu');
      root.querySelectorAll('[data-ev-menu-box]').forEach(function (b) {
        var show = b.getAttribute('data-ev-menu-box') === which ? b.hidden : false;
        b.hidden = !show;
      });
      root.querySelectorAll('[data-ev-menu]').forEach(function (b) {
        var box = root.querySelector('[data-ev-menu-box="' + b.getAttribute('data-ev-menu') + '"]');
        b.setAttribute('aria-expanded', box && !box.hidden ? 'true' : 'false');
      });
      return;
    }
    var eb = t.closest('[data-ev-eb]');
    if (eb && !ebBound) { ev.preventDefault(); openCheckout(null); }
  });

  /* ---------------------------------------------------------------- phone bar */
  var mbar = root.querySelector('[data-ev-mbar]');
  var slabEl = root.querySelector('[data-ev-slab]');
  var mq = window.matchMedia('(max-width: 720px)');
  var barOn = false;
  function syncBar() {
    if (!mbar) return;
    var want = false;
    if (mq.matches) {
      want = true;
      if (slabEl) { var r = slabEl.getBoundingClientRect(); want = r.bottom < 90 || r.top > window.innerHeight - 60; }
      var heroBtn = root.querySelector('.ev-hero [data-ev-buy]');
      if (heroBtn) { var hr = heroBtn.getBoundingClientRect(); if (hr.bottom > 0 && hr.top < window.innerHeight) want = false; }
    }
    if (want === barOn) return;
    barOn = want;
    mbar.classList.toggle('is-on', want);
    document.body.classList.toggle('ev-hasbar', want);
  }
  var tick = false;
  var queue = function () { if (tick) return; tick = true; requestAnimationFrame(function () { tick = false; syncBar(); }); };
  window.addEventListener('scroll', queue, { passive: true });
  window.addEventListener('resize', queue, { passive: true });
  if (mq.addEventListener) mq.addEventListener('change', syncBar);
  syncBar();

  /* Arriving on #tickets from another page opens the checkout straight away
     on a phone, where the panel would otherwise be a long scroll down. */
  if (location.hash === '#tickets' && ebBtn && mq.matches && d.status !== 'past') {
    setTimeout(function () { var s = root.querySelector('[data-ev-slab]'); if (s) s.scrollIntoView({ block: 'start' }); }, 50);
  }
})();
